module.exports = __webpack_public_path__ + "static/img/3-active.099ac9e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer4/nav/3-active.png
// module id = rBrb
// module chunks = 0